import React from "react";

import { Article } from "custom-types/Wordpress";

import NewsArticleDate from "components/news/NewsArticleDate";

const AuthorHeader: React.FC<{
  article: Article;
}> = ({ article }) => {
  const { author, date, modified } = article;
  return (
    <div data-testid="author-header" className="flex flex-col">
      <a className="font-bold text-sm" href={author.urlPath} rel="author">
        {author.name}
      </a>
      <NewsArticleDate date={date} modified={modified} />
    </div>
  );
};

export default AuthorHeader;
